import { getAccount } from './accountUtil'

export default {
  getIdTokenHeaderAsync: async () => {
    const account = getAccount()
    const idToken = account ? await account.getIdToken() : ''
    return {
      headers: {
        Authorization: `bearer ${idToken}`
      }
    }
  }
}
